import moment from 'moment';
import { useEffect, useMemo, useState } from 'react';
import { getReportData, getTotalCount } from '../../../api/reports';
import { Layout } from '../../../common/components';
import NoReports from '../../../common/components/noReport/noReport';
import { useSetLoading } from '../../../common/hooks/appearance';
import * as handlers from '../../../utils/handlers';
import DetailedContractFilters from '../components/detailedContractFilters/detailedContractFilters';
import GenerateTrust from '../components/generateTrust/generateTrust';
import TrustDetailedReportData from '../components/tables/monthlyReportTable/TrustDetailedReport';

export default function TrustDetailedReport() {
  const [loading, setLoading] = useState(false);
  const [applyFilters, setApplyFilters] = useState(false);
  const [showTable, setShowTable] = useState({
    show: false,
    tableName: '',
    tableData: [],
    fromDate: null,
    toDate: null,
    trustType: 0,
    needType: 0,
    totalResults: null,
    page: 1,
    limit: 5,
    isSearchResult: false,
    hasDownloadFunctionality: true,
  });

  useEffect(() => {
    if (applyFilters && showTable?.show) {
      generateTable(showTable.fromDate, showTable.toDate);
    }
    if (!showTable.show) {
      setApplyFilters(false);
    }
  }, [showTable]);

  const generateTable = async (fromDate, toDate) => {
    setApplyFilters(false);
    setShowTable({ ...showTable, fromDate, toDate });
    const requestParams = {
      startDate: fromDate,
      endDate: toDate,
      trustType: showTable?.entity?.toString() !== '' ? showTable?.entity?.toString() : undefined,
      needType:
        showTable?.agreementTypes?.toString() !== ''
          ? showTable?.agreementTypes?.toString()
          : undefined,
      businessUnit:
        showTable?.businessUnits?.toString() !== ''
          ? showTable?.businessUnits?.toString()
          : undefined,
      timezone: moment.tz.guess().toString(),
    };
    setLoading(true);
    try {
      generateTableRecordsCount(fromDate, toDate);
      const response = await getReportData('trustDetailedReport', requestParams);
      setShowTable((state) => {
        const obj = {
          ...state,
          show: true,
          fromDate,
          toDate,
          isSearchResult: false,
          tableData: response?.data?.data?.result || [],
          page: response?.data?.data?.page || 0,
          limit: response?.data?.data?.limit || 0,
        };
        return obj;
      });
      setLoading(false);
    } catch (error) {
      setLoading(false);
      handlers.apiErrorHandler(error);
    }
  };

  const generateTableRecordsCount = async (fromDate, toDate) => {
    setApplyFilters(false);
    setShowTable({ ...showTable, fromDate, toDate });
    const requestParams = {
      startDate: fromDate,
      endDate: toDate,
      trustType: showTable?.entity?.toString() || undefined,
      needType: showTable?.agreementTypes?.toString() || undefined,
      businessUnit: showTable?.businessUnits?.toString() || undefined,
      timezone: moment.tz.guess().toString(),
    };
    try {
      setShowTable((state) => {
        const obj = {
          ...state,
          totalResults: 'Loading...',
        };
        return obj;
      });
      const response = await getTotalCount('trustDetailedReport', requestParams);
      setShowTable((state) => {
        const obj = {
          ...state,
          totalResults: response?.data?.data?.totalCount || 0,
        };
        return obj;
      });
    } catch (error) {
      setShowTable((state) => {
        const obj = {
          ...state,
          totalResults: 0,
        };
        return obj;
      });
      handlers.apiErrorHandler(error);
    }
  };

  const getTitle = () => {
    return 'Detailed Contract Report';
  };

  const showLoading = useMemo(() => loading, [loading]);
  useSetLoading(showLoading);
  return (
    <Layout>
      <DetailedContractFilters setShowTable={setShowTable} setApplyFilters={setApplyFilters} />
      <h3 className="account-heading">Detailed Contract Allocation Report</h3>
      <GenerateTrust
        contractType={showTable?.contractType}
        setShowTable={setShowTable}
        trustType={showTable?.trustType}
        needType={showTable?.needType}
        title="Detailed Contract Allocation Report"
        description="Generate Detailed Contract Allocation Report"
        onGenerateClick={generateTable}
      />
      <hr />
      {showTable.show ? (
        <TrustDetailedReportData
          setShowTable={setShowTable}
          showTable={showTable}
          title={getTitle()}
          subtitle={`From: ${moment(showTable?.fromDate).format(
            'MM-DD-YYYY',
          )} To: ${moment(showTable?.toDate).format('MM-DD-YYYY')}`}
        />
      ) : (
        <div className="noreports-trust">
          <NoReports />
        </div>
      )}
    </Layout>
  );
}
